import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, RefreshCw, MessageCircle } from "lucide-react";
import { api, BACKEND, errMsg } from "../lib/api";
import { Card, Btn } from "./ui";

export const ShareCardPreview = ({ postId, slug, title, image, published }) => {
  const [src, setSrc] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/admin/posts/${postId}/share-card`, { responseType: "blob" });
      setSrc((old) => { if (old) URL.revokeObjectURL(old); return URL.createObjectURL(data); });
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  useEffect(() => { load(); }, [postId]); // eslint-disable-line react-hooks/exhaustive-deps

  const shareUrl = `${BACKEND}/api/share/blog/${slug}`;
  return (
    <Card title="WhatsApp share card" testid="share-card">
      <p className="mb-3 text-xs text-zinc-500">Shown when this post is shared on WhatsApp, Telegram, Facebook or X. Built from your featured image and title.</p>
      <div className="overflow-hidden rounded-xl border border-[#D4AF37]/25 bg-black/40">
        {src ? <img src={src} alt="Share card preview" className="aspect-[1200/630] w-full object-cover" data-testid="share-card-img" />
          : <div className="grid aspect-[1200/630] place-items-center text-xs text-zinc-600">{busy ? "Rendering…" : "No preview"}</div>}
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        <Btn variant="outline" onClick={load} disabled={busy} data-testid="share-card-refresh"><RefreshCw size={14} /> Refresh</Btn>
        {src && <a href={src} download={`${slug || "share-card"}.jpg`} className="btn-outline !py-2" data-testid="share-card-download"><Download size={14} /> Download</a>}
        {published && <a href={`https://wa.me/?text=${encodeURIComponent(`${title} ${shareUrl}`)}`} target="_blank" rel="noreferrer" className="btn-gold !py-2" data-testid="share-card-whatsapp"><MessageCircle size={14} /> Share</a>}
      </div>
      {!image && <p className="mt-2 text-xs text-amber-300/80">Tip: add a featured image for a richer card.</p>}
      <p className="mt-2 text-[11px] text-zinc-600">Save the post to update the card after changing the title or image.</p>
    </Card>
  );
};
